import Vue from "vue";
import axios from 'axios'

const EventBus = new Vue();

export const updateUserStatus = (user_id, status, css) => {
    //console.log(user_id, status)
    let user_boxes = $('.user-online-' + user_id)
    user_boxes.each(function (e) {
        let element = $(this)
        //console.log(element)
        if (element.hasClass(css)) {
            element.addClass('is-show')
        } else {
            element.removeClass('is-show')
        }
    })

    updateIconsUsersLists()
    //chat box
    let chat_box = $('.card-chat-' + user_id)
    removeClassRegex(/^is-/, chat_box).addClass(css)
}

export const updateIconsUsersLists = () => {
    $('.users-list').each(function () {
        let element = $(this)
        //console.log(element)
        let is_show = element.children().hasClass('is-show')
        //console.log(is_show)
        if (is_show) {
            //console.log(element.children().first())
            element.children().first().show()
        } else {
            element.children().first().hide()
        }

    })
}

export const hideOverlay = (name) => {
    axios.post('/admin/hide-overlay', {name: name})
        .then(function (response) {
            $('.' + name).hide()
        })
}

export const removeClassRegex = (regex, element) => {
    return element.removeClass(function (index, classes) {
        return classes.split(/\s+/).filter(function (c) {
            return regex.test(c)
        }).join(' ')
    })
}

export const setVisitTime = (countDownDate) => {
    // Update the count down every 1 second
    let visitTimer = setInterval(function() {

        // Get todays date and time
        let now = new Date().getTime();

        // Find the distance between now and the count down date
        let distance = now - countDownDate;

        // Time calculations for days, hours, minutes and seconds
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = (days*24) + Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Output the result in an element with id="demo"

        $('.visit-time').each(function () {
            $(this).html(hours + "h "
                + minutes + "m " + seconds + "s ")
        });
        /*document.getElementsByClassName("visit-time").innerHTML = hours + "h "
            + minutes + "m " + seconds + "s ";*/

    }, 1000);
}

export const eventBus = {
    $on(event, callback) {
        EventBus.$on(event, callback);
    },
    // TODO: Unregister the event listener to avoid memory leaks
    $off(event, callback) {
        EventBus.$off(event, callback);
    },
    $emit(event, ...args) {
        EventBus.$emit(event, ...args);
    },
}

export const formatTimeAgo = (timestamp) => {
    const timeDifference = Math.floor((new Date() - new Date(timestamp)) / 1000);

    const timeUnits = [
        { unit: 'day', secondsInUnit: 24 * 60 * 60 },
        { unit: 'hour', secondsInUnit: 60 * 60 },
        { unit: 'minute', secondsInUnit: 60 },
        { unit: 'second', secondsInUnit: 1 },
    ];

    for (const time of timeUnits) {
        const value = Math.floor(timeDifference / time.secondsInUnit);
        if (value > 0) {
            return `${value} ${time.unit}${value > 1 ? 's' : ''} ago`;
        }
    }

    return 'Just now';
}

export const formatDateTime = (dateTimeString) => {
    const date = new Date(dateTimeString);
    const now = new Date();
    const diff = now - date;
    const oneDay = 24 * 60 * 60 * 1000;
    const oneWeek = 7 * oneDay;

    // Adjust time if it's midnight
    const adjustTime = (timeString) => {
        if (timeString.startsWith('00')) {
            return timeString.replace(/^00/, '12').replace(/pm/, 'am');
        }
        return timeString;
    };

    // Check if the date is today
    if (date.toDateString() === now.toDateString()) {
        return `Today at ${adjustTime(date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true }))}`;
    }
    // Check if the date is yesterday
    else if (date.toDateString() === new Date(now - oneDay).toDateString()) {
        return `Yesterday at ${adjustTime(date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true }))}`;
    }
    // For dates within this week
    else if (diff < oneWeek) {
        const options = { weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: true };
        return `${adjustTime(date.toLocaleDateString([], options))}`;
    }
    // For dates more than this week
    else {
        return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    }
}

export const isSafari = () => {
    // Check if the user agent string indicates Safari
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

export function formatFileName(fileName) {
    const maxLength = 13;

    if (!fileName || fileName.length <= maxLength) {
        return fileName || '';
    }

    const extensionIndex = fileName.lastIndexOf('.');
    const fileNameWithoutExtension = fileName.substring(0, extensionIndex);
    const truncatedFileName = fileNameWithoutExtension.substring(0, maxLength - 3) + '...';

    return truncatedFileName + fileName.substring(extensionIndex);
}

export const debounce = (func, delay) => {
    let timerId;
    return function(...args) {
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}

export const formatPeriod = (input, year = null, mode = false, uppercase = false) => {
    let yearValue, month;

    if (typeof input === 'string') {
        [yearValue, month] = input.split('-');
    } else {
        month = input;
        yearValue = year;
    }

    const date = new Date(yearValue, month - 1);
    const monthFormat = mode ? 'long' : 'short';

    let monthName = date.toLocaleString('default', { month: monthFormat });

    if (uppercase) {
        monthName = monthName.toUpperCase();
    } else {
        monthName = `${monthName.charAt(0).toUpperCase()}${monthName.slice(1).toLowerCase()}`;
    }

    return `${monthName} ${date.getFullYear()}`;
}

export const formatCurrency = (amount) => {
    const parsedAmount = parseFloat(amount);
    const isNegative = parsedAmount < 0;
    const absoluteAmount = Math.abs(parsedAmount).toFixed(2);
    const formattedAmount = absoluteAmount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return (isNegative ? '-$' : '$') + formattedAmount;
}

export const formatNumber = (number) => {
    // Convert string numbers to actual numbers
    if (typeof number === 'string') {
        number = parseFloat(number);
    }

    // Check if the input is a valid number
    if (isNaN(number) || !isFinite(number)) {
        return number;
    }

    // Format the number based on its magnitude
    let formattedNumber;

    if (number >= 1000000) {
        formattedNumber = (number / 1000000).toFixed(1);
        if (formattedNumber.endsWith('.0')) {
            formattedNumber = formattedNumber.slice(0, -2);
        }
        return formattedNumber + 'M';
    } else if (number >= 1000) {
        formattedNumber = (number / 1000).toFixed(1);
        if (formattedNumber.endsWith('.0')) {
            formattedNumber = formattedNumber.slice(0, -2);
        }
        return formattedNumber + 'K';
    }

    return number.toString();
};

export const truncateText = (text, maxLength) => {
    if (!text || typeof text !== 'string') {
        return '-';
    }

    if (text.length > maxLength) {
        return text.substring(0, maxLength - 3) + '...';
    }

    return text;
}

export const transformText = (text) => {
    if (!text || typeof text !== 'string') {
        return '-';
    }

    let transformedText = text.replace(/_/g, ' ');
    transformedText = transformedText.charAt(0).toUpperCase() + transformedText.slice(1);

    return transformedText;
}

export const fireworksOptions = {
    autoresize: true,
    opacity: 0.5,
    acceleration: 1.00,
    friction: 0.97,
    gravity: 1.5,
    particles: 200,
    traceLength: 6.67,
    traceSpeed: 30,
    explosion: 10,
    intensity: 46.53,
    flickering: 67.39,
    lineStyle: 'round',
    hue: {
        min: 0,
        max: 345
    },
    delay: {
        min: 30,
        max: 60
    },
    rocketsPoint: {
        min: 0,
        max: 100
    },
    lineWidth: {
        explosion: {
            min: 1,
            max: 8.06
        },
        trace: {
            min: 0.10,
            max: 7.42
        }
    },
    brightness: {
        min: 71,
        max: 100
    },
    decay: {
        min: 0.015,
        max: 0.03
    }
}

export const adjustDropdownPosition = (maxAttempts = 20) => {
    let attempts = 0;

    const tryAdjusting = () => {
        const buttonExport = $('#crudTable_wrapper .dt-buttons .btn-group .dt-button-collection');
        const buttonColVis = $('#crudTable_wrapper .dt-buttons .btn-group .buttons-colvis + .dt-button-collection');

        if (buttonExport.length > 0) {
            const exportHeight = buttonExport.outerHeight();
            const exportStyle = `#crudTable_wrapper .dt-buttons .btn-group .dt-button-collection:not(.buttons-colvis) {top: -${exportHeight}px !important;}`;
            $('head').append($('<style>').text(exportStyle));
        }

        if (buttonColVis.length > 0) {
            const colVisHeight = buttonColVis.outerHeight();
            const colVisStyle = `#crudTable_wrapper .dt-buttons .btn-group .buttons-colvis + .dt-button-collection {top: -${colVisHeight}px !important;}`;
            $('head').append($('<style>').text(colVisStyle));
        }

        // Retry if neither button is found yet
        if ((buttonExport.length === 0 || buttonColVis.length === 0) && attempts < maxAttempts) {
            attempts++;
            setTimeout(tryAdjusting, 500);
        }
    };

    tryAdjusting();
};

export const getMonthOptions = () => {
    return [
        { label: 'January', value: '1' },
        { label: 'February', value: '2' },
        { label: 'March', value: '3' },
        { label: 'April', value: '4' },
        { label: 'May', value: '5' },
        { label: 'June', value: '6' },
        { label: 'July', value: '7' },
        { label: 'August', value: '8' },
        { label: 'September', value: '9' },
        { label: 'October', value: '10' },
        { label: 'November', value: '11' },
        { label: 'December', value: '12' },
    ];
};

export function getYearOptions(range = 5) {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: range }, (_, i) => currentYear + i);
};

export function getDurationOptions() {
    return Array.from({ length: 12 }, (_, i) => {
        const totalMinutes = (i + 1) * 10;
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        let label = '';
        if (hours > 0) {
            label += `${hours} hour${hours > 1 ? 's' : ''}`;
        }
        if (minutes > 0) {
            if (label) label += ' ';
            label += `${minutes} minutes`;
        }
        if (!label) {
            label = `${totalMinutes} minutes`;
        }

        return {
            label,
            value: totalMinutes,
        };
    });
};

export function formatDuration(totalMinutes) {
    if (totalMinutes == null || isNaN(totalMinutes) || totalMinutes <= 0) {
        return '-';
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    let label = '';
    if (hours > 0) {
        label += `${hours} hour${hours > 1 ? 's' : ''}`;
    }
    if (minutes > 0) {
        if (label) label += ' ';
        label += `${minutes} minutes`;
    }

    if (!label) {
        label = `${totalMinutes} minutes`;
    }

    return label;
};
